export default __webpack_public_path__ + "assets/annotations.129cb85426ecbfd670cab436af126b22.png";